module.exports = __webpack_public_path__ + "img/smartphone.33f9225a.svg";